/* Dependencies */
import styled, { css } from 'styled-components';

/* Components */
import { Breakpoints } from 'kinedu-react-components';
import { Button, Texter } from 'lego-dist';

/* Icons */
import magnifyingGlass from 'images/icons/magnifyingGlass.svg';

export const StylesImageModalResultsAddedMember = css`
  margin: 30px auto;
  width: 60px;
  height: auto;
`;

export const CenterTab = styled.div.attrs(() => ({
  className: 'CenterTabView',
}))`
  padding: 0 16px;
  width: 100%;

  ${({ theme }) => theme.breakPoints.tablet} {
    padding: 0 32px;
  }
`;

export const DirectorHeader = styled.div.attrs(() => ({
  className: 'DirectorHeader',
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 60px;
  width: 100%;
`;

export const DirectorCount = styled.div.attrs(() => ({
  className: 'DirectorCount',
}))`
  display: none;

  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 16px;
  font-weight: bold;

  ${({ theme }) => theme.breakPoints.tablet} {
    display: block;
  }
`;

export const DirectorActions = styled.div.attrs(() => ({
  className: 'DirectorActions',
}))`
  display: flex;
  align-items: center;
  width: 100%;

  ${({ theme }) => theme.breakPoints.tablet} {
    width: min-content;
  }
`;

export const SearchBar = styled(Texter).attrs(() => ({
  className: 'DirectorSearch',
}))`
  margin-right: 16px;

  & .texter-input {
    border: 1px solid #acc2d3;
    border-radius: 20px;
    color: #8295a3;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    padding-left: 16px;

    height: 40px;
    width: 100%;
  }

  & .texter-input::placeholder {
    color: #8295a3;
    font-style: normal;
    font-weight: normal;
    vertical-align: center;
  }

  ${Breakpoints.tablet} {
    & .texter-input {
      width: 180px;
    }
  }
`;

export const SearchIcon = styled.img.attrs(() => ({
  className: 'DirectorSearchIcon',
  src: magnifyingGlass,
}))`
  height: 21px;
  right: 16px;
  position: absolute;
  top: 25%;
  width: 13px;
`;

export const AddDirectorBtn = styled(Button).attrs(() => ({
  className: 'AddDirectorButton',
}))`
  display: none;

  ${({ theme }) => theme.breakPoints.tablet} {
    display: block;
    min-width: 170px;
  }
`;

export const AddDirectorBtnMobile = styled(Button).attrs(() => ({
  className: 'AddDirectorButtonMobile',
}))`
  font-size: 35px;
  height: 40px;
  width: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.breakPoints.tablet} {
    display: none;
  }
`;
